import { onDocumentReady } from '../utils/dom';
import './react/ShopTheLook';
import './styles/index.scss';
import initBgVideo from './background-video';
import initVideoImageBlocks from './video-image-blocks';
import initLooks from './looks';
import initQuickShop from './quick-shop-simplified';
import initVideoGallery from './video-gallery';

onDocumentReady(() => (
  initBgVideo(),
  initVideoImageBlocks(),
  initQuickShop(),
  initLooks(),
  initVideoGallery()
));

